module.exports = {
  async getPlaces() {
    // TODO: 1つしかないけどちゃんとAPI呼びたい
    // API連携したら削除
    const response = { data: [{ id: 1, name: '技術センター' }] };
    // const url = `${this.url}/${this.version}/places`;
    // const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/places_api.js